import { render, staticRenderFns } from "./layout-chat-left.vue?vue&type=template&id=21d1e767&scoped=true"
import script from "./layout-chat-left.vue?vue&type=script&lang=js"
export * from "./layout-chat-left.vue?vue&type=script&lang=js"
import style0 from "./layout-chat-left.vue?vue&type=style&index=0&id=21d1e767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1e767",
  null
  
)

export default component.exports